<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ea-audit-sync-actions [pages]="['FINANCIAL', 'REAL_ESTATE', 'COMPANIES']"></ea-audit-sync-actions>
    <fieldset disabled class="audit-locked">
    <div class="row mb">
      <div class="col col-md-12">
        <pr-input-column
          label="Evaluation de votre patrimoine global brut"
          [derrors]="derrors"
          [isDefault]="false"
          [suffix]="'€'"
        >
          <input notdot formControlName="amount" type="text" />
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <pr-panel
          ><div class="man pr-panel">
            <pr-panel-body
              ><div class="pr-panel-body undefined">
                <div
                  class="pr-card-swiper animated fadeIn relative overflow-hidden"
                >
                  <table class="pr-table-card-container" style="width: 100%">
                    <tbody class="pr-table-card-statistics-body">
                      <ng-container>
                        <div class="pr-table-card-row ng-star-inserted">
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >Actifs financiers</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('financialAssets')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >En liquidités</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('liquidity')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >En actifs professionnels</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('professionalAssets')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >En immobilier d'investissement</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('realEstateInvestment')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >En immobilier de jouissance</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('realEstateUse')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div></pr-panel-body
            >
          </div>
        </pr-panel>
      </div>
    </div>
    </fieldset>
    <div class="row mt">
      <div class="col-md-12">
        <pr-color-panel [display]="allocationPanel.display">
          <pr-panel-body clazz="pam">
            <pr-label
              [name]="allocationPanel.icon"
              [width]="18"
              [height]="18"
              >{{ allocationPanel.text }}</pr-label
            >
          </pr-panel-body>
        </pr-color-panel>
      </div>
    </div>
    <div class="row mt">
      <div class="col col-md-12">
        <pr-input-radio
          formControlName="subjectToIfi"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Foyer soumis à l’IFI"
        >
        </pr-input-radio>
      </div>
      <div class="col col-md-12">
        <pr-input-column
          label="Montant de l’IFI”"
          [derrors]="derrors"
          [isDefault]="false"
          [hidden]="form.get('subjectToIfi')?.value == false"
        >
          <input
            [required]="form.get('subjectToIfi')?.value == true"
            notdot
            formControlName="ifi"
            type="text"
          />
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
